import Vue from 'vue'
import VeeValidate, {Validator} from 'vee-validate'
import zh from 'vee-validate/dist/locale/zh_CN' // 引入中文

// 配置中文
Validator.localize(zh)

const config = {
  errorBagName: 'errors',
  delay: 0,
  locale: 'zh_CN',
  events: 'input|blur'
}

// 自定义validate
const dictionary = {
  zh_CN: {
    messages: { // 提示语
      required: field => `请输入${field}`,
      email: () => '邮箱格式不正确'
    },
    attributes: { // filed
      account: '账号',
      password: '密码'
    }
  }
}

Validator.localize(dictionary)

Vue.use(VeeValidate, config)

// 手机号
Validator.extend('phone', {
  getMessage: field => `${field}必须是11位数字`,
  validate: value => {
    return value.length === 11 && /^1[3-8]{1}\d{9}$/.test(value)
  }
})

// 密码
Validator.extend('password', {
  getMessage: field => `${field} 必须是6-16位数字或者字母`,
  validate: value => {
    return /^[0-9A-Za-z]{6,16}$/.test(value)
  }
})

// 确认密码
VeeValidate.Validator.extend('confirmedPassword', {
  getMessage: field => '两次输入密码不一致',
  validate: (value, val2) => {
    console.log(value)
    console.log(val2)
    return value === val2
  }
})



// WEBPACK FOOTER //
// ./src/common/js/validate.js